class TabNavigation {
    // options (optional): tabs / contents = selectors of the tab items and panels inside the container, for a container that
    // holds the tab row and its panels apart (the shared category post page: the row above the sort section, the panels in the
    // results); viewMore: false = no "View more" links; activeClass = the class the open tab carries. The panels are read on each switch, so a replaced panel set still works
    constructor(container, options = {}) {
      this.container = document.querySelector(container);
      if (!this.container) {
        console.error('Container not found!');
        return;
      }
      this.tabSelector = options.tabs || '.c-tabs-item';
      this.contentSelector = options.contents || '.c-tab-navigation-content';
      this.tabs = this.container.querySelectorAll(this.tabSelector);
      this.view_more_links = options.viewMore === false ? [] : this.container.querySelectorAll('.read-more-link-with-icon');
      this.activeClass = options.activeClass || 'c-tabs-item-active';
      this.hiddenClass = 'c-hidden';
  
      this.init();
    }
  
    init() {
      // Bind click event to each tab
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.onTabClick(e, tab));
      });

      if ( this.view_more_links.length > 0 ) {
        this.view_more_links.forEach(link => {
          link.addEventListener('click', (e) => this.onViewMoreClick(e, link));
        });
      }
    }

    onViewMoreClick( e, link ){
      e.preventDefault();
    
      const $link = $(link);
      const $linksList = $link.prev('.linksList');
      if (!$linksList.length) return;
    
      const $span = $link.find('span');
      const $arrow = $link.find('i');
      const isViewMore = $.trim($span.text()) === "View more";
    
      $span.text(isViewMore ? "View less" : "View more");
      $arrow.toggleClass('fa-chevron-down', !isViewMore).toggleClass('fa-chevron-up', isViewMore);
    
      if (!$linksList.data('hiddenItems')) {
        const hiddenItems = $linksList.find('.c-hidden').map((_, item) => $(item).index()).get();
        $linksList.data('hiddenItems', hiddenItems);
        
        const $lastItem = $linksList.find('.c-linkItem-last-item');
        if ($lastItem.length) {
          $linksList.data('lastItemIndex', $lastItem.index());
        }
      }
    
      $.each($linksList.data('hiddenItems'), (_, index) => {
        $linksList.children().eq(index).toggleClass('c-hidden', !isViewMore);
      });
    
      if ($linksList.data('lastItemIndex') !== undefined) {
        const $lastItem = $linksList.children().eq($linksList.data('lastItemIndex'));
        if (isViewMore) {
          $lastItem.removeClass('c-linkItem-last-item');
        } else {
          $lastItem.addClass('c-linkItem-last-item');
        }
      }
    }
    
  
    onTabClick(event, tab) {
      const targetKey = tab.getAttribute('data-tab-item-key');
      this.activateTab(targetKey);
    }
  
    activateTab(key) {
      // the n-th tab opens the n-th panel (tab-<n>)
      const index = parseInt(String(key).replace('tab-', ''), 10) - 1;
      const contents = this.container.querySelectorAll(this.contentSelector);

      // Deactivate all tabs
      this.tabs.forEach(tab => tab.classList.remove(this.activeClass));
      contents.forEach(content => content.classList.add(this.hiddenClass));

      // Activate the clicked tab and its corresponding content
      if (this.tabs[index]) this.tabs[index].classList.add(this.activeClass);
      if (contents[index]) contents[index].classList.remove(this.hiddenClass);
    }
  }